// extracted by mini-css-extract-plugin
module.exports = {"NavbarButton":"NavbarButton_NavbarButton__1NW0B","Selected":"NavbarButton_Selected__171g7"};